import * as React from 'react';
import Typography from '@components/typography';

const CarwowLogo = ({
  className,
  colour,
  'data-cy': dataCy,
  width,
  height,
  ...props
}: React.SVGProps<SVGSVGElement> & { colour?: 'white'; 'data-cy': string }) => {
  const logoColour = colour === 'white' ? '#FFFFFF' : '#00A4FF';

  return (
    <svg
      className={className}
      data-cy={dataCy}
      height={height}
      id="carwow-logo"
      viewBox="0 0 440 103.7"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Typography
        variant="caption"
        size="lg"
        weight="bold"
        colour="alternative"
      >
        Carwow
      </Typography>
      <path
        fill={logoColour}
        d="M74.4,75.8c-1,1.1-2.3,2.1-3.9,3.1c-1.6,1-3.3,1.8-5.3,2.5c-2,0.7-4,1.3-6.1,1.7c-2.1,0.4-4.2,0.6-6.3,0.6
			c-4.4,0-8.5-0.8-12.4-2.5s-7.3-3.9-10.2-6.8c-2.9-2.9-5.2-6.3-6.8-10.2c-1.7-3.9-2.5-8-2.5-12.4c0-4.4,0.8-8.5,2.5-12.4
			c1.7-3.9,3.9-7.3,6.8-10.2c2.9-2.9,6.3-5.2,10.2-6.8s8-2.5,12.4-2.5c3.8,0,7.4,0.5,10.9,1.5c3.4,1,6.4,2.5,8.9,4.7
			c2,1.8,3.1,3.8,3.1,6c0,1.4-0.5,2.7-1.4,3.9c-1.6,1.9-3.6,2.9-6.1,2.9c-1.7,0-3.3-0.4-4.7-1.3c-1.6-0.9-3.2-1.6-4.9-2.2
			c-1.7-0.5-3.6-0.8-5.7-0.8c-2.4,0-4.5,0.5-6.4,1.4c-1.9,0.9-3.4,2.2-4.7,3.7c-1.3,1.5-2.3,3.3-3,5.4c-0.7,2.1-1,4.3-1,6.6
			s0.3,4.5,1,6.6c0.7,2.1,1.7,3.9,3,5.4c1.3,1.5,2.9,2.8,4.7,3.7c1.9,0.9,4,1.4,6.4,1.4c3,0,5.4-0.5,7.3-1.5c1.9-1,3.5-1.9,4.7-2.7
			c1.5-1.1,3.2-1.7,5.2-1.7c2,0,3.8,0.8,5.1,2.4c1.1,1.4,1.7,2.9,1.7,4.6C76.8,72.1,76,74,74.4,75.8z"
      />
      <path
        fill={logoColour}
        d="M138,80.8c-1.6,1.6-3.5,2.4-5.9,2.4c-2.2,0-4.1-0.9-5.8-2.6c-1.6-1.7-2.4-3.7-2.4-5.9c-0.5,1-1.3,2.1-2.4,3.1
			c-1.1,1.1-2.5,2-4,2.9c-1.6,0.9-3.3,1.6-5.2,2.2s-3.9,0.8-5.9,0.8c-4.2,0-8.1-0.8-11.7-2.5s-6.8-3.9-9.5-6.8
			c-2.7-2.9-4.8-6.3-6.3-10.2c-1.5-3.9-2.3-8-2.3-12.4c0-4.4,0.8-8.5,2.5-12.4c1.7-3.9,3.9-7.3,6.8-10.2c2.9-2.9,6.3-5.2,10.2-6.8
			c3.9-1.7,8-2.5,12.4-2.5c4.4,0,8.5,0.8,12.4,2.5c3.9,1.7,7.3,3.9,10.2,6.8c2.9,2.9,5.1,6.3,6.8,10.2c1.7,3.9,2.5,8,2.5,12.4V75
			C140.4,77.3,139.6,79.2,138,80.8z M122.6,45.3c-0.7-2-1.6-3.8-2.9-5.4c-1.3-1.5-2.9-2.7-4.7-3.6c-1.9-0.9-4-1.3-6.4-1.3
			s-4.5,0.4-6.4,1.3c-1.9,0.9-3.4,2.1-4.7,3.6c-1.3,1.5-2.3,3.3-2.9,5.4c-0.7,2-1,4.2-1,6.5s0.3,4.5,0.9,6.5c0.6,2,1.5,3.8,2.7,5.3
			c1.2,1.5,2.7,2.7,4.5,3.6c1.8,0.9,3.9,1.3,6.3,1.3c2.4,0,4.6-0.4,6.5-1.3c1.9-0.9,3.5-2.1,4.9-3.6c1.3-1.5,2.4-3.3,3.1-5.3
			c0.7-2,1.1-4.2,1.1-6.5S123.2,47.4,122.6,45.3z"
      />
      <path
        fill={logoColour}
        d="M187.2,32.9c-1.4,1.4-3.2,2.2-5.4,2.2c-2.5,0-5,0.3-7.4,0.9c-2.5,0.6-4.6,1.6-6.5,2.8c-1.9,1.3-3.4,3-4.6,4.9
			c-1.2,2-1.7,4.4-1.7,7.3v23.8c0,2.3-0.8,4.3-2.4,5.9c-1.6,1.6-3.6,2.4-5.9,2.4c-2.3,0-4.3-0.8-6-2.4c-1.7-1.6-2.5-3.6-2.5-5.9V29
			c0-2.3,0.8-4.3,2.5-6c1.7-1.7,3.7-2.5,6-2.5c2.3,0,4.3,0.8,5.8,2.5c1.6,1.7,2.4,3.7,2.4,6c1.5-1.8,3-3.2,4.5-4.4
			c1.5-1.2,3-2.1,4.6-2.8c1.6-0.7,3.3-1.2,5.2-1.5c1.9-0.3,3.9-0.4,6.3-0.4c2.1,0,3.9,0.7,5.4,2.2c1.4,1.4,2.2,3.2,2.2,5.4
			S188.6,31.4,187.2,32.9z"
      />
      <path
        fill={logoColour}
        d="M276.7,29.6c-0.1,0.5-0.2,0.9-0.4,1.4l-17.9,47.4c-0.6,1.5-1.5,2.6-2.8,3.5c-1.3,0.8-2.7,1.3-4.3,1.3
			c-1.6,0-3-0.5-4.2-1.4c-1.3-0.9-2.1-2.1-2.7-3.6l-9.6-26.7l-9.6,26.7c-0.6,1.5-1.5,2.7-2.7,3.6c-1.3,0.9-2.7,1.4-4.2,1.4
			c-1.6,0-3-0.4-4.3-1.3c-1.3-0.8-2.2-2-2.8-3.5L193.1,31c-0.2-0.5-0.3-0.9-0.4-1.4c-0.1-0.5-0.1-0.9-0.1-1.4c0-2.1,0.7-3.9,2.2-5.4
			s3.3-2.2,5.4-2.2c1.6,0,3,0.4,4.2,1.3c1.2,0.8,2.1,2,2.6,3.5l10.6,28.9l10.3-28.7c0.6-1.5,1.4-2.7,2.6-3.6
			c1.2-0.9,2.6-1.4,4.2-1.4c1.6,0,3,0.5,4.2,1.4c1.2,0.9,2.1,2.1,2.6,3.6l10.3,28.7l10.6-28.8c0.6-1.5,1.5-2.7,2.7-3.6
			c1.3-0.9,2.7-1.3,4.2-1.3c2.1,0,3.9,0.7,5.4,2.2c1.4,1.5,2.1,3.3,2.1,5.4C276.9,28.7,276.8,29.1,276.7,29.6z"
      />
      <path
        fill={logoColour}
        d="M336.1,64.2c-1.7,3.9-3.9,7.3-6.8,10.2c-2.9,2.9-6.3,5.2-10.2,6.8s-8,2.5-12.4,2.5c-4.4,0-8.5-0.8-12.4-2.5
			s-7.3-3.9-10.2-6.8c-2.9-2.9-5.2-6.3-6.8-10.2c-1.7-3.9-2.5-8-2.5-12.4c0-4.4,0.8-8.5,2.5-12.4c1.7-3.9,3.9-7.3,6.8-10.2
			c2.9-2.9,6.3-5.2,10.2-6.8s8-2.5,12.4-2.5c4.4,0,8.5,0.8,12.4,2.5s7.3,3.9,10.2,6.8c2.9,2.9,5.2,6.3,6.8,10.2
			c1.7,3.9,2.5,8,2.5,12.4C338.6,56.2,337.8,60.4,336.1,64.2z M320.9,45.3c-0.7-2-1.7-3.8-3-5.4c-1.3-1.5-2.9-2.7-4.7-3.6
			c-1.9-0.9-4-1.3-6.4-1.3c-2.4,0-4.5,0.4-6.4,1.3c-1.9,0.9-3.4,2.1-4.7,3.6c-1.3,1.5-2.3,3.3-2.9,5.4c-0.7,2-1,4.2-1,6.5
			s0.3,4.5,1,6.5c0.7,2,1.6,3.8,2.9,5.3c1.3,1.5,2.9,2.7,4.7,3.6c1.9,0.9,4,1.3,6.4,1.3c2.4,0,4.6-0.4,6.4-1.3
			c1.9-0.9,3.4-2.1,4.7-3.6c1.3-1.5,2.3-3.3,3-5.3c0.7-2,1-4.2,1-6.5S321.6,47.4,320.9,45.3z"
      />
      <path
        fill={logoColour}
        d="M420.9,29.6c-0.1,0.5-0.2,0.9-0.4,1.4l-17.9,47.4c-0.6,1.5-1.5,2.6-2.8,3.5c-1.3,0.8-2.7,1.3-4.3,1.3
			c-1.6,0-3-0.5-4.2-1.4c-1.3-0.9-2.1-2.1-2.7-3.6l-9.6-26.7l-9.6,26.7c-0.6,1.5-1.5,2.7-2.7,3.6c-1.3,0.9-2.7,1.4-4.2,1.4
			c-1.6,0-3-0.4-4.3-1.3c-1.3-0.8-2.2-2-2.8-3.5L337.2,31c-0.2-0.5-0.3-0.9-0.4-1.4c-0.1-0.5-0.1-0.9-0.1-1.4c0-2.1,0.7-3.9,2.2-5.4
			s3.3-2.2,5.4-2.2c1.6,0,3,0.4,4.2,1.3s2.1,2,2.6,3.5l10.6,28.9L372,25.6c0.6-1.5,1.4-2.7,2.6-3.6c1.2-0.9,2.6-1.4,4.2-1.4
			c1.6,0,3,0.5,4.2,1.4c1.2,0.9,2.1,2.1,2.6,3.6L396,54.2l10.6-28.8c0.6-1.5,1.5-2.7,2.7-3.6c1.3-0.9,2.7-1.3,4.2-1.3
			c2.1,0,3.9,0.7,5.4,2.2c1.4,1.5,2.1,3.3,2.1,5.4C421,28.7,421,29.1,420.9,29.6z"
      />
    </svg>
  );
};

export default CarwowLogo;
